//@flow
import reducer from "./reducers";

import * as tagsOperations from "./operations";
import * as tagsSelectors from "./selectors";

export { tagsOperations, tagsSelectors };

export default reducer;
